import { ServiceDefinition } from '@pershing/pershing-core';

export class OverviewHoldingsServiceDefinition implements ServiceDefinition {
    private static instance: ServiceDefinition = null;

    uri: string = 'positions'
    version: string = 'v1';
    family: string = 'netxinvestor';
    appName: string = 'positions-svc';
    serviceName: string = 'app';
    mnemonic: string = 'nxc';

    static getInstance(): ServiceDefinition {
        if (!OverviewHoldingsServiceDefinition.instance) {
            OverviewHoldingsServiceDefinition.instance = new OverviewHoldingsServiceDefinition();
        }
        return OverviewHoldingsServiceDefinition.instance;
    }
    
}